module.exports = __webpack_public_path__ + "static/img/aquaman5_esp.58e87f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/aquaman5_esp.png
// module id = AXg3
// module chunks = 1